// Use the shared Facade singleton from the framework package so that
// internal framework modules (ModulesManager, etc.) and game code operate
// on the exact same object reference.
import { Facade } from '@dragonframework/modules'

// Extend with game-specific defaults (all typed through @/modules IFacade)
Object.assign(Facade, {
    gameVersion: '1.0.0',
    isDebug: true,
    isQuickSpin: false,
    isTurboSpin: false,
    isAuto: false,
    requestOngoing: false,

    displayConfig: null,
    symbolAnimationsConfig: null,
    reelsConfig: null,
    anticipationConfig: null,
    symbolsConfig: null,
    winningsConfig: null,
    defaultConfig: null,

    renderer: null,
    resizer: null,
    orientation: null,
    container: null,

    urlParams: null,
    payouts: null,
    model: null,
    status: null,
    currentState: null,
    isPopupBlockingInput: false,
    reelsStates: null,
    _showTournament: false,
    _showTournamentBadge: false,
})

export default Facade
